module.exports = {"530303001":"西平街道","530303002":"龙华街道","530303003":"金龙街道","530303004":"花山街道","530303101":"白水镇","530303102":"盘江镇","530303201":"炎方乡","530303202":"播乐乡","530303203":"大坡乡","530303204":"菱角乡","530303205":"德泽乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530303.json
// module id = 2554
// module chunks = 0